// ANCHOR API
import { ICpdUnitsRewardPayload } from '@lyon/utils/api/payloads/reward';

/**
 * Returns the highest CPD Unit in an event/course
 *
 * @param cpdUnitsRewards Array of CPD Unit Rewards
 */
export const getHighestCPD = (cpdUnitsRewards?: ICpdUnitsRewardPayload[]) => (
  cpdUnitsRewards?.reduce((acc, { units }) => (acc > units ? acc : units), 0)
);
